import React from 'react'
import { Box } from '@mui/material'
import DialogAdd from './Add'
import Liste from './Liste'
import SearchBar from './SearchBar'
import Title from '../../../SpiderWebSite/components/Title'
import AddModule from '../../../components/GestionFonctionnalite/Module/AddModule'
import ListeModule from '../../../components/GestionFonctionnalite/Module/ListeModule'

export default function Droit() {
    return (
        <Box sx={{ flexGrow: 1, width: "100%" }}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                {/*---------------- debut titre --------------*/}
                <Title
                    intitule='Droit'
                />
                {/*---------------- fin titre --------------*/}


                {/*---------------- debut add --------------*/}

                <Box sx={{ width: "50%" }}>
                    <SearchBar />
                </Box>

                {/*---------------- fin add --------------*/}


                {/*---------------debut SearchBar --------- */}

                <Box>
                    <AddModule />
                </Box>

                {/* ------------------fin  SearchBar ------------*/}
            </Box>

            {/*---------------- debut Liste -----------------*/}
            <ListeModule />
            {/*--------------- fin Liste ------------------ */}
        </Box>
    )
}
